import { useEffect, useRef } from 'react'
import classNames from 'classnames'
import styles from './Player.module.css'

interface Player {
  once: (event: string, func: () => void) => void
  reload: () => void
  [key: string]: any
}

interface Props {
  videoUrl: string
  poster: string
  width: number
  height: number
}

export default function Player({ videoUrl, poster, width, height }: Props) {
  const playOptions = {
    id: 'mse',
    fluid: true,
    autoplay: false,
    playsinline: true,
    closeVideoTouch: true,
    // 忽略原生plugins 使用自定义plugins
    ignores: ['enter', 'loading', 'error'],
    'x5-video-player-type': 'h5',
    'x5-video-player-fullscreen': 'false',
  }

  const myPlayer = useRef<Player>()

  const initPlayerPlugins = () => {
    const Player = require('xgplayer')
    let liveLoading = function (this: any) {
      let player = this
      let util = Player.util
      let container = util.createDom(
        // 自定义 html元素
        'xg-loading',
        `
                <div class="xgplayer-inner">
                  <img src="/images/player/loading.svg"/>
                  <p>正在加载  请稍后...</p>
                </div>
              `,
        {},
        // class name
        'xgplayer-myloading'
      )

      player.once('ready', () => {
        if (!util.findDom(player.root, '.xgplayer-myloading')) {
          player.root.appendChild(container)
        }
      })
    }

    let liveEnter = function (this: any) {
      let player = this
      let util = Player.util
      let container = util.createDom(
        // 自定义 html元素
        'xg-enter',
        `
            <div class="xgplayer-inner">
              <img src="/images/player/loading.svg"/>
              <p>正在加载  请稍后...</p>
            </div>
            `,
        {},
        // class name
        'xgplayer-myenter'
      )
      player.once('ready', () => {
        if (!util.findDom(player.root, '.xgplayer-myenter')) {
          player.root.appendChild(container)
        }
      })
    }

    let liveError = function (this: any) {
      let player = this
      let util = Player.util
      let error: HTMLElement
      if (player.config.url) {
        error = util.createDom(
          'xg-error',
          `
                <div class="xgplayer-error-refresh xgplayer-inner">
                  <img src="/images/player/error.svg"/>
                  <p>网络开小差了  请检查网络...</p>
                </div>
              `,
          {},
          'xgplayer-myerror'
        )
      } else {
        error = util.createDom(
          'xg-error',
          `
              <div class="xgplayer-inner">
                <img src="/images/player/review.svg"/>
                <p>视频源错误...</p>
              </div>
              `,
          {},
          'xgplayer-myerror'
        )
      }
      player.once('ready', () => {
        if (!util.findDom(player.root, '.xgplayer-myerror')) {
          player.root.appendChild(error)
        }
      })
      let refresh: Element | null
      function onError() {
        util.addClass(player.root, 'xgplayer-is-error')
        refresh = error.querySelector('.xgplayer-error-refresh')
        if (refresh) {
          ;['touchend', 'click'].forEach(item => {
            refresh?.addEventListener(
              item,
              function (e: {
                preventDefault: () => void
                stopPropagation: () => void
              }) {
                e.preventDefault()
                e.stopPropagation()
                player.autoplay = true
                let currentTime = player.currentTime
                player.once('playing', () => {
                  player.currentTime = currentTime
                  util.removeClass(player.root, 'xgplayer-is-error')
                })
                player.src = player.config.url
              }
            )
          })
        }
      }
      player.on('error', onError)
      function onDestroy() {
        player.off('error', onError)
        player.off('destroy', onDestroy)
      }
      player.once('destroy', onDestroy)
    }

    Player.install('liveLoading', liveLoading)
    Player.install('liveEnter', liveEnter)
    Player.install('liveError', liveError)
  }

  const createPlayer = () => {
    if (!document?.getElementById('mse')) return

    const Player = require('xgplayer')
    myPlayer.current = new Player({
      ...playOptions,
      poster: poster,
      lastPlayTime: 0,
      lastPlayTimeHideDelay: 5,
      url: videoUrl,
      isLive: false,
      playbackRate: [0.5, 0.75, 1, 1.5, 2],
      width: width,
      height: height,
    })
  }

  const isMp3 = (url: string) => {
    return !!url.match(/\S+(\.mp3|\.wma)$/)
  }

  useEffect(() => {
    initPlayerPlugins()
    createPlayer()
  }, [])

  return (
    <>
      <div
        id="mse"
        className={classNames(styles.myPlayer, {
          controlsShow: isMp3(videoUrl as string),
        })}
      ></div>
    </>
  )
}
